// @flow

export const LIST_PADDING = 8
